import { MediaComponent } from 'strapi/component/shared/types';

export interface SeoCardProps {
  generalCard?: GeneralCardProps;
  openGraphCard?: OpenGraphCardProps;
}

export interface GeneralCardProps {
  title?: string;
  description?: string;
  canonical?: string;
  disableIndexing?: boolean;
}

export const OpenGraphTypes = ['website' as const, 'article' as const];
export type OpenGraphType = (typeof OpenGraphTypes)[number];

export interface OpenGraphCardProps {
  title?: string;
  description?: string;
  type?: OpenGraphType;
  imageUrl?: string;
  imageAlt?: string;
}

export interface GeneralCardStrapiComponent {
  title?: string;
  description?: string;
  canonical?: string;
}

export interface OpenGraphCardStrapiComponent {
  title?: string;
  description?: string;
  type?: string;
  image?: MediaComponent;
}

export interface SeoStrapiComponent {
  openGraphCard?: OpenGraphCardStrapiComponent;
  generalCard?: GeneralCardStrapiComponent;
}
